module.exports = __webpack_public_path__ + "img/clock-icon.b724dd1f.png";